import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Chip, Tab, Tabs } from '@mui/material';
import { CURRENT_WINDOW_DAYS } from '../../../store/utils/shipmentUtils';
import { navigateToPreset } from '../../../store/thunks/shipstationShipmentThunks';

const TabLabel = ({ label, count, loading }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    {label}
    <Chip
      label={loading ? '...' : count}
      size='small'
      sx={{
        height: 18,
        fontSize: '0.7rem',
        minWidth: 24,
        '& .MuiChip-label': { px: 0.5 },
      }}
    />
  </Box>
);

TabLabel.propTypes = {
  label: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
};

const ShipstationPresetTabs = () => {
  const dispatch = useDispatch();
  const { activeSubcategory, activeFacility, counts } = useSelector(
    ({ shipstationShipment }) => shipstationShipment
  );

  const allCount =
    activeFacility === 'all'
      ? counts.awaiting.total
      : counts.awaiting.byPharmacy[activeFacility] || 0;
  const recentCount =
    activeFacility === 'all'
      ? counts.awaiting.recent
      : counts.awaiting.recentByPharmacy[activeFacility] || 0;

  const handleChange = (_, newValue) => {
    dispatch(navigateToPreset({ preset: newValue }));
  };

  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}>
      <Tabs
        value={activeSubcategory}
        onChange={handleChange}
        sx={{
          minHeight: 36,
          '& .MuiTab-root': { minHeight: 36, py: 0, textTransform: 'none' },
        }}
      >
        <Tab
          label={<TabLabel label='All' count={allCount} loading={counts.loading} />}
          value='all'
        />
        <Tab
          label={
            <TabLabel
              label={`Last ${CURRENT_WINDOW_DAYS}d`}
              count={recentCount}
              loading={counts.loading}
            />
          }
          value='recent'
        />
      </Tabs>
    </Box>
  );
};

export default ShipstationPresetTabs;
